import React from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { useMatch, useResolvedPath } from 'react-router'
import { motion } from 'framer-motion'
import { Button } from '@demandlocal/components'
import classNames from 'classnames'

type Props = {
  index: number
}

const TabMenuItem = ({
  children,
  to,
  className,
  index,
  target,
  ...props
}: LinkProps & Props): JSX.Element => {
  const resolved = useResolvedPath(to)
  const match = useMatch({ path: resolved.pathname, end: false })
  return (
    <div className={`font-Spartan relative ${index > 0 && 'ml-6'}`}>
      <div className="w-full">
        <Link
          className={classNames('font-bold text-decoration-none text-sm', {
            'text-primary-persian-blue': match,
            'text-primary-xiketic opacity-40': !match,
          })}
          target={target}
          to={to}
          {...props}>
          {children}
        </Link>

        {match && (
          <motion.div
            className={'absolute w-full border-b-2 pb-3 border-primary-persian-blue'}
            transition={{ type: 'spring', stiffness: 300, damping: 40, mass: 1 }}
            layoutId={`tabBarActiveItem-${to}`}
          />
        )}
      </div>
    </div>
  )
}

export default TabMenuItem
